import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, AsyncSubject } from 'rxjs';
import { Router } from '@angular/router';

import { Subscription, SubscribersGetResponse } from "./../dataTypes/Subscription";
import { Guest } from "./../dataTypes/Guest";
import { Site } from "./../dataTypes/Site";


import { AuthServiceGuest } from './AuthServiceGuest';
import { createEditSubscriberModel, convertResidentToSubscriberModel } from '../dataTypes/createEditSubscriberModel';
import { ConfigService } from '../shared/services/config.service';
import { Park } from '../dataTypes/Park';
import { ParkForReservedSubscriber } from '../dataTypes/ParkForReservedSubscriber';
import { MaxSubscribersToCreatePerPark } from '../dataTypes/MaxSubscribersToCreatePerPark';
import { Company } from '../dataTypes/GuestSubsCompany';
import { User } from '../dataTypes/user';
import { ControllerResponse } from '../dataTypes/ControllerResponse';
import { NewUserModel } from '../dataTypes/NewUserModel';
import { EntryTicket } from '../dataTypes/EntryTicket';
import { LabelProfile } from '../dataTypes/LabelProfile';

//import moment from 'moment';



@Injectable()
export class GuestsService {



  private url = '';//(<any>window).appSettings.guestUrl;

  public subscriptions: BehaviorSubject<Subscription[]> = new BehaviorSubject([]);
  public subscriptions$ = this.subscriptions.asObservable();

  public subscriptionsSave: BehaviorSubject<Subscription[]> = new BehaviorSubject([]);
  public subscriptionsSave$ = this.subscriptionsSave.asObservable();


  private subscriptionsError: BehaviorSubject<any> = new BehaviorSubject(null);
  public subscriptionsError$ = this.subscriptionsError.asObservable();

  public guests: BehaviorSubject<Guest[]> = new BehaviorSubject([]);
  public guests$ = this.guests.asObservable();

  public guestsSave: BehaviorSubject<any> = new BehaviorSubject({});
  public guestsSave$ = this.guestsSave.asObservable();

  public sites: BehaviorSubject<Site[]> = new BehaviorSubject([]);
  public sites$ = this.sites.asObservable();

  public sitesError: BehaviorSubject<any> = new BehaviorSubject([]);
  public sitesError$ = this.sitesError.asObservable();

  private guestsError: BehaviorSubject<any> = new BehaviorSubject(null);
  public guestsError$ = this.guestsError.asObservable();

  public counting: BehaviorSubject<any> = new BehaviorSubject('');
  public counting$ = this.counting.asObservable();

  private countingError: BehaviorSubject<any> = new BehaviorSubject(null);
  public countingError$ = this.countingError.asObservable();





  public _isAtidim: boolean;
  public _isWeizman: boolean;

  public _selectedCompany: Company;
  public _companiesList: Company[];

  public selectedCompanySubject: BehaviorSubject<Company> = new BehaviorSubject<Company>(null);// initial value



  //private selectedCompanySubject: BehaviorSubject<Company> = new BehaviorSubject(this._selectedCompany);
  //public selectedCompanySubject$ = this.selectedCompanySubject.asObservable();

  constructor(public _ConfigService: ConfigService, private _http: HttpClient, private _router: Router, private _AuthService: AuthServiceGuest) {

    this.url = _ConfigService._serverUrl;
    console.debug(this.url);
    this._isAtidim = null;
  }



  setSelectedCompany(company: Company) {

    this._selectedCompany = company;
    this.selectedCompanySubject.next(this._selectedCompany);
  }


  checkToken(): void {
    if (!this._AuthService.isLoggedInGuests()) {
      window.location.replace('/login');
    }
  }


  addCompanyToUser(company: Company, id: number): Observable<boolean> {


    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<boolean>(this.url + '/Users/AddCompanyToUser?userID=' + id + '&companyID=' + company.id, { headers: reqHeader });
  }

  deleteCompanyFromUser(company: Company, id: number): Observable<boolean> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<boolean>(this.url + '/Users/deleteCompanyFromUser?userID=' + id + '&companyID=' + company.id, { headers: reqHeader });
  }

  editUser(user: User): Observable<ControllerResponse> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.post<ControllerResponse>(this.url + '/Users/editUser', user, { headers: reqHeader });
  }


  addUser(user: NewUserModel): Observable<ControllerResponse> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.post<ControllerResponse>(this.url + '/Users/addUser', user, { headers: reqHeader });
  }

  deleteUser(id: number): Observable<ControllerResponse> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });
    let strOut = this.url + '/Users/deleteUser?userID=' + id.toString();
    console.debug(strOut);
    return this._http.post<ControllerResponse>(strOut, null, { headers: reqHeader });
  }

  getUsers(): Observable<User[]> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<User[]>(this.url + '/Users/GetUsers', { headers: reqHeader });
  }

  getAllParks(): Observable<ParkForReservedSubscriber[]> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<ParkForReservedSubscriber[]>(this.url + '/api/Parks/GetAllParks', { headers: reqHeader });
  }



  getCompanies(userID: string): Observable<Company[]> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<Company[]>(this.url + '/Companies/GetCompanies?userId=' + userID, { headers: reqHeader });
  }


  getParksForReservedSubscriber(): Observable<ParkForReservedSubscriber[]> {


    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<ParkForReservedSubscriber[]>(this.url + '/api/Parks/GetParksForReservedSubscriber?companyId=' + this._selectedCompany.id.toString(), { headers: reqHeader });
  }



  getOverflowLevels(): Observable<boolean> {

    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<boolean>(this.url + '/api/Parks/GetOverflowLevels?companyId=' + this._selectedCompany.id.toString(), { headers: reqHeader });
  }

  getParks(): Observable<Park[]> {

    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<Park[]>(this.url + '/api/Parks/GetParks?companyId=' + this._selectedCompany.id.toString(), { headers: reqHeader });
  }


  public getMaximumSubscribersToCreatePerParks(): Observable<MaxSubscribersToCreatePerPark[]> {

    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<MaxSubscribersToCreatePerPark[]>(this.url + '/MaximumSubscribersToCreatePerParks?companyId=' + this._selectedCompany.id.toString(), { headers: reqHeader });
  }



  public getCounting(): Observable<object> {

    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get(this.url + '/GetCompany?companyId=' + this._selectedCompany.id.toString(), { headers: reqHeader });
  }

  public getGuests(search: string, userID: string): Observable<Guest[]> {

    this.checkToken();

    if (search) {
      search = encodeURIComponent(`%${search}%`);     
    }

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    //--------------
    //if (userID === "Administrator") {
    //  return this._http.get<Guest[]>(this.url + '/api/Guest/GetGuest?companyId=' + this._selectedCompany.id.toString() + '&userId=' + 3 +
    //    '&searchCriteria=' + search,
    //    { headers: reqHeader });
    //}
    //--------------

    return this._http.get<Guest[]>(this.url + '/api/Guest/GetGuest?companyId=' + this._selectedCompany.id.toString()
      + '&userId=' + userID +
      '&searchCriteria=' + search,
      { headers: reqHeader });
  }

  public getSubscriptions(search: string, userID: string, pageNumber: number, pageSize: number): Observable<SubscribersGetResponse> {

    this.checkToken();
    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<SubscribersGetResponse>(this.url + '/api/Subscriber/GetSubscriber?companyId=' +
      this._selectedCompany.id.toString() + '&userId=' + userID + '&searchCriteria=' + search + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber, { headers: reqHeader })
  }

  public addGuest(data: Guest): Observable<object> {

    this.checkToken();


    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.post(this.url + '/api/Guest', data, { headers: reqHeader })
  }

  public editGuest(data: Guest): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.put(this.url + '/api/Guest', data, { headers: reqHeader })
  }

  public deleteGuest(id): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    var user = this._AuthService.getUserInfo();

    return this._http.delete(this.url + '/api/Guest?guestID=' + id + '&userId=' + user.Id, { headers: reqHeader })
  }

  public addSubscription(data: createEditSubscriberModel): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.post(this.url + '/api/Subscriber', data, { headers: reqHeader })
  }

  public editSubscription(data: createEditSubscriberModel): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.put(this.url + '/api/Subscriber', data, { headers: reqHeader })
  }

  public deleteSubscription(id): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });


    var user = this._AuthService.getUserInfo();

    return this._http.delete(this.url + '/api/Subscriber?monthly=' + id + '&userId=' + user.Id, { headers: reqHeader })
  }



  public convertResidentToSubscriber(data: convertResidentToSubscriberModel): Observable<object> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.post(this.url + '/api/Subscriber/convertResidentToSubscriber', data, { headers: reqHeader })
  }









  public get_isWeizman(): Observable<boolean> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<boolean>(this.url + '/api/VirtualValidation/getIsWeizman', { headers: reqHeader })
  }


  public getLabelsProfiles(): Observable<LabelProfile[]> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<LabelProfile[]>(this.url + '/api/VirtualValidation/labelsProfiles', { headers: reqHeader })
  }

  public getEntryTickets(searchByEntryTicketNumber: string): Observable<EntryTicket[]> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    return this._http.get<EntryTicket[]>(this.url + '/api/VirtualValidation/getTickets?ticket=' + searchByEntryTicketNumber, { headers: reqHeader })
  }

  public setVirtualValidation(entryTicket: EntryTicket, profileNumber: number): Observable<ControllerResponse> {

    this.checkToken();

    var authToken = this._AuthService.getAuthTokenGuests();

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    });

    var user = this._AuthService.getUserInfo();

    return this._http.get<ControllerResponse>(this.url + '/api/VirtualValidation/setVirtualValidation?ticket=' + entryTicket.number +
      '&date=' + entryTicket.issueDate + '&profileNumber=' + profileNumber + '&userID=' + user.Id, { headers: reqHeader })
  }


  //private handleError(error: any) {
  //    // In a real world app, we might use a remote logging infrastructure
  //    // We'd also dig deeper into the error to get a better message
  //    let errMsg = (error.message) ? error.message :
  //        error.status ? `${error.status} - ${error.statusText}` : 'Server error';

  //    if (error.status === 401 || error.status === 403) {
  //        // window.location.replace('/login');
  //    }
  //    return Observable.throw(errMsg);
  //}

}
